import {Box, Icon, Tooltip} from "@mui/material";
import {getLabelEstado} from "../../shared/estados";
import {getSituacaoOcorrencia} from "../../shared/situacaoOcorrencia";
import IconBadge from "../icon-badge/IconBadge";

function IconEstado({estado, semCor, ocorrencia}) {
    let color;
    let icon;

    switch (estado) {
        case "AGUARDANDO_APROVACAO":
            color = "info";
            icon = "fact_check";
            break;
        case "EM_FILA":
            color = "primary";
            icon = "pending";
            break;
        case "PROCESSAMENTO":
            icon = "cached";
            color = "warning";
            break;
        case "PROCESSADO_COM_SUCESSO":
            color = "success";
            icon = "check_circle_outline";
            break;
        case "PROCESSADO_COM_ERRO":
            color = "error";
            icon = "error_outline";
            break;
        case "RESULTADO_INDETERMINADO":
            color = "warning";
            icon = "report_problem";
            break;
        default:
            color = "default";
            icon = "queue";
    }

    const situacao = ocorrencia ? getSituacaoOcorrencia(ocorrencia) : null;
    color = situacao?.color || color;
    icon = situacao?.icon || icon;
    return (
        <Tooltip title={situacao?.label || getLabelEstado(estado)}>
            <Box component="span" sx={{display: "inline-flex", flexShrink: 0}}>
                {semCor ? (
                    <Icon>{icon}</Icon>
                ) : (
                    <IconBadge color={color} size={32}>
                        {icon}
                    </IconBadge>
                )}
            </Box>
        </Tooltip>
    );
}

export default IconEstado;
